// Crude but works for now. Looks for 'render' in the url to determine if the app is in render
// mode. This enables us to switch off a lot of redundant scripts and initialisation.
class Render {
  static isRenderMode() {
    return window.location.href.indexOf("render") >= 0;
  }
}

export default Render;
